/**
 * Simple class name joiner for semantic class names only.
 * Used for conditional className application (hover states, animations).
 *
 * Note: This project uses CSS-in-JS with inline style objects for all styling.
 * className is only used for hover/focus states and animations defined in global.css.
 *
 * @example
 * cn('event-card', isNew && 'event-card-new')
 * cn('button-primary', disabled && 'button-disabled')
 */
export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ')
}
